export const maxPageGlobal = 10;